// CloudPayments / CloudTips decline reason codes → payer-facing messages
// Docs: https://developers.cloudpayments.ru/ (Коды ошибок)
export const CLOUDPAYMENTS_ERROR_MESSAGES: Record<string, string> = {
  // 50xx — card / issuer / network declines
  '5001': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5003': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5004': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5005': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5006': 'Проверьте правильность введенных данных карты или воспользуйтесь другой картой',
  '5007': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5012': 'Воспользуйтесь другой картой или свяжитесь с банком, выпустившим карту',
  '5013': 'Проверьте корректность суммы',
  '5014': 'Проверьте правильность введенных данных карты или воспользуйтесь другой картой',
  '5015': 'Проверьте правильность введенных данных карты или воспользуйтесь другой картой',
  '5017': 'Воспользуйтесь другой картой',
  '5019': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5030': 'Повторите попытку позже',
  '5031': 'Воспользуйтесь другой картой',
  '5033': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5034': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5036': 'Платежи для этой карты запрещены. Попробуйте другую карту',
  '5041': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5043': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5051': 'Недостаточно средств на карте',
  '5054': 'Проверьте правильность введенных данных карты или воспользуйтесь другой картой',
  '5055': 'Воспользуйтесь другой картой',
  '5057': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5058': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5059': 'Свяжитесь с банком или воспользуйтесь другой картой',
  '5061': 'Превышение лимита оплаты по карте. Измените настройки лимита или оплатите другой картой',
  '5062': 'Платежи для этой карты запрещены. Попробуйте другую карту',
  '5063': 'Воспользуйтесь другой картой',
  '5065': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5082': 'Неверно указан код CVV',
  '5091': 'Повторите попытку позже или воспользуйтесь другой картой',
  '5092': 'Повторите попытку позже или воспользуйтесь другой картой',
  '5096': 'Повторите попытку позже',
  '5113': 'Воспользуйтесь другой картой',
  '5204': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5206': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5207': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5300': 'Воспользуйтесь другой картой',
  '5303': 'Свяжитесь с вашим банком или воспользуйтесь другой картой',
  '5761': 'Воспользуйтесь другой картой',
  '5762': 'Воспользуйтесь другой картой',
  '5763': 'Воспользуйтесь другой картой',

  // 60xx — SBP / subscription / payout declines
  '6001': 'Невозможно провести оплату',
  '6002': 'Невозможно провести оплату',
  '6003': 'Невозможно провести оплату',
  '6004': 'Обратитесь в поддержку сайта',
  '6005': 'Невозможно провести оплату',
  '6006': 'Невозможно провести оплату',
  '6007': 'Невозможно провести оплату',
  '6008': 'Невозможно провести оплату',
  '6009': 'Невозможно провести оплату',
  '6010': 'Невозможно провести оплату',
  '6011': 'Невозможно провести оплату',
  '6013': 'Невозможно провести оплату',
  '6014': 'Невозможно провести оплату',
  '6015': 'Невозможно провести оплату',
  '6016': 'Невозможно провести оплату',
  '6017': 'Невозможно провести оплату',
  '6021': 'Невозможно провести выплату',
  '6022': 'Невозможно провести выплату',
  '6025': 'Невозможно провести оплату',
};

// HTTP status codes for mapped CloudPayments / CloudTips decline errors
export const CLOUDPAYMENTS_ERROR_STATUS_CODES: Record<string, number> = Object.fromEntries(
  Object.keys(CLOUDPAYMENTS_ERROR_MESSAGES).map((errorCode) => [errorCode, 422]),
);
